import { ArrowLeft } from 'react-bootstrap-icons';

import './style.scss';

export interface SelectedLoginUserProps {
  username: string;
  onBack: () => void;
  backLabel?: string;
}

function SelectedLoginUser({ username, onBack, backLabel = 'Back' }: SelectedLoginUserProps) {
  return (
    <div className="dec-selected-login-user">
      <button
        aria-label={backLabel}
        className="dec-selected-login-user__back"
        onClick={onBack}
        type="button">
        <ArrowLeft aria-hidden="true" focusable="false" />
      </button>
      <span className="dec-selected-login-user__username">{username}</span>
    </div>
  );
}

export default SelectedLoginUser;
